export default __webpack_public_path__ + "static/media/closeModal.dd287d17.svg";